import React from 'react';

import { h1, h2, h3, h4, heavy as heavyStyle } from './headline.style';

const Headline = ({
  tag = '1',
  theme = 'h1',
  heavy = false,
  children,
  ...props
}) => {
  const Tag = `h${tag}`;
  const styles = {
    h1,
    h2,
    h3,
    h4,
  };

  return (
    <Tag css={[styles[theme], heavy && heavyStyle]} {...props}>
      {children}
    </Tag>
  );
};

export default Headline;
